import styled from 'styled-components';

export const FooterWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const FooterText = styled.div`
  ${({ theme }) => theme.font.t2};
  line-height: 20px;
  color: ${({ theme }) => theme.color.ui2};
`;

export const FooterLink = styled.a`
  ${({ theme }) => theme.font.t3};
  line-height: 20px;
  cursor: pointer;
  color: ${({ theme }) => theme.color.s1};
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.color.s2};
  }
`;
